const PersonIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15" cy="9" r="4" fill="#AFB1BA" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.4685 19.4144C24.792 19.6731 24.8444 20.1451 24.5857 20.4685L22.5857 22.9685C22.4524 23.1351 22.2545 23.2371 22.0415 23.2489C21.8285 23.2607 21.6205 23.1812 21.4697 23.0304L20.4697 22.0304C20.1768 21.7375 20.1768 21.2626 20.4697 20.9697C20.7626 20.6768 21.2374 20.6768 21.5303 20.9697L21.9371 21.3765L23.4143 19.5315C23.6731 19.2081 24.1451 19.1556 24.4685 19.4144Z"
      fill="#AFB1BA"
    />
    <path
      d="M21.8272 19.1137L21.6433 19.3434C20.8773 19.1156 20.0138 19.3041 19.409 19.9089C18.5303 20.7876 18.5303 22.2122 19.409 23.0909L19.4207 23.1026C18.2154 23.6642 16.6765 24.001 15 24.001C11.134 24.001 8 22.2101 8 20.001C8 17.7918 11.134 16.001 15 16.001C18.3324 16.001 21.1209 17.3316 21.8272 19.1137Z"
      fill="#AFB1BA"
    />
  </svg>
);

export default PersonIcon;
